// client/src/components/auth/AuthInput.js
import React from 'react';

const AuthInput = ({ icon: Icon, label, id, rightElement, error, ...props }) => (
    <div className="auth-input-group">
        <label htmlFor={id}>{label}</label>
        <div className={`auth-input-wrap${error ? ' is-invalid' : ''}`}>
            <Icon size={18} className="auth-input-icon" />
            <input
                id={id}
                className="auth-input"
                aria-invalid={error ? 'true' : undefined}
                aria-describedby={error ? `${id}-error` : undefined}
                {...props}
            />
            {rightElement && <div className="auth-input-right">{rightElement}</div>}
        </div>
        {error && <p className="auth-input-error" id={`${id}-error`}>{error}</p>}
    </div>
);

export default AuthInput;
